import ApplicationSerializer from '@square/dashboard-data/serializers/application';
import { underscore } from '@ember/string';
export default ApplicationSerializer.extend({
  primaryKey: 'token',
  keyForAttribute(attr) {
    if (attr === 'webToken') {
      return attr;
    }
    return underscore(attr);
  },
  normalizeResponse(store, primaryModelClass, payload, id, requestType) {
    return this._super(store, primaryModelClass, payload, id, requestType);
  }
});